import React, { useEffect, useState } from 'react';

import { IQuestion } from 'modules/national-certificate';

import TopSection from '../top-section';

import Options from './options';
import Questions from './questions';

interface IProps {
  data?: IQuestion;
}

const ExclusiveSubsTest: React.FC<IProps> = ({ data }) => {
  const [answers, setAnswers] = useState<Record<number, number | null>>({});

  useEffect(() => {
    if (data?.sub_questions) {
      const initial = Object.fromEntries(
        data.sub_questions.map(q => [q.id, q.checked && q.checked !== 0 ? q.checked : null])
      );

      setAnswers(initial);
    }
  }, [data?.sub_questions]);

  const handleUpdateAnswer = (subQuestionId: number, optionId: number | null) => {
    setAnswers(prev => ({ ...prev, [subQuestionId]: optionId }));
  };

  return (
    <div className="shadow-xs space-y-3 rounded-xl bg-white px-4 py-3">
      <TopSection testImage={data?.image} questionId={data?.question_id} title={data?.question_name} />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div className="space-y-3">
          {data?.sub_questions?.map((question, index) => (
            <Questions
              index={index}
              key={question?.id}
              question={question}
              length={data?.sub_questions?.length}
              selectedOptionId={answers[question.id]}
              allOptions={data.options}
            />
          ))}
        </div>
        <div className="rounded-xl border border-gray-200 p-3">
          <Options
            subQuestions={data?.sub_questions}
            options={data?.options}
            answers={answers}
            onUpdateAnswer={handleUpdateAnswer}
          />
        </div>
      </div>
    </div>
  );
};

export default ExclusiveSubsTest;
